<section class="px-4 py-12 lg:px-40 xl:px-52.5" [class.hidden]="!partners().length">
    <div class="border-neutral-variant-40/20 rounded-lg border py-12">
        <span class="lg:text-display-small text-title-large mb-6 flex justify-center">
            {{ fundingBlock().translations_refs | getTranslation: "title" }}
        </span>
        <figure class="flex flex-wrap justify-center gap-4 lg:gap-12">
            @for (partner of partners(); track partner) {
                @if (partner?.logo) {
                    <a [href]="partner?.url" target="_blank">
                        <img
                            [ngSrc]="partner?.logo | getDirectusImage"
                            width="250"
                            height="150"
                            [alt]="partner?.name || 'Partner logo'"
                            class="max-h-37.5 min-h-37.5 max-w-62.5 min-w-62.5 object-contain"
                        />
                    </a>
                }
            }
        </figure>
    </div>
</section>
